import { render, staticRenderFns } from "./ArtistPictureList.vue?vue&type=template&id=19584de5&scoped=true&"
import script from "./ArtistPictureList.vue?vue&type=script&lang=js&"
export * from "./ArtistPictureList.vue?vue&type=script&lang=js&"
import style0 from "./ArtistPictureList.vue?vue&type=style&index=0&id=19584de5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19584de5",
  null
  
)

export default component.exports